module.exports = __webpack_public_path__ + "static/img/stzl.f1f5a74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stzl.png
// module id = 62ai
// module chunks = 1